import { roleCheck, UserRole } from "@core/shared/access";
import { VirtualPropertyBaseDefinition } from "@core/shared/virtual-properties";
export class UserVirtualPropertyBaseDefinition extends VirtualPropertyBaseDefinition {
  getValidAccessGroups() {
    return ['self', 'manager', 'managerOfUser', 'admin', 'public'];
  }
  // TODO: #86c11upzw - reimplement based on abilities
  getGrantedAccessGroupsForUserAndItem(item, access) {
    const accessGroups = [];
    accessGroups.push('public');
    if (access.isAdmin) accessGroups.push('admin');
    const userId = access.getAccessData('userId', null, 'null');
    const editsSelf = userId === item.id;
    if (editsSelf) accessGroups.push('self');
    const isManager = access.simpleAbilityCheck('Feature.common-users.Company.Manage');
    if (isManager) {
      accessGroups.push('manager');
      const isNoAdvancedUser = !roleCheck(UserRole.MANAGER, item.userRole);
      if (isNoAdvancedUser && this.userIsInManagedCompany(item, access)) {
        accessGroups.push('managerOfUser');
      }
    }
    return accessGroups;
  }
  userIsInManagedCompany(user, access) {
    const companyId = user.companyId || user.company?.id;
    const managedCompany = access.getAccessData('managedCompany', null, 'throw');
    if (!companyId) return false;
    if (!managedCompany?.id) return false;
    return companyId === managedCompany.id;
  }
}